import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { NgxPermissionsModule } from "ngx-permissions";
import { MaterialModule } from "../../../components/material/material.module";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { CrearCompetidorComponent } from "./crear-competidor/crear-competidor.component";
import { CrearCompetidorDialog } from "./crear-competidor/crear-competidor-dialog/crear-competidor-dialog.component";
import { EditarCompetidorComponent } from "./editar-competidor/editar-competidor.component";
import { EditarCompetidorDialog } from "./editar-competidor/editar-competidor-dialog/editar-competidor-dialog.component";
import { EliminarCompetidorComponent } from "./eliminar-competidor/eliminar-competidor.component";
import { EliminarCompetidorDialog } from "./eliminar-competidor/eliminar-competidor-dialog/eliminar-competidor-dialog.component";
import { IrCompetidorComponent } from "./ir-competidor/ir-competidor.component";
import { CompetidorComponent } from "./competidor/competidor.component";
import { RouterModule } from "@angular/router";
import { PipesModule } from "../../../pipes/pipes.module";
import { VerCompetidoresComponent } from "./ver-competidores/ver-competidores.component";
import { CompetidorService } from "../../../providers/competidor.service";

@NgModule({
    imports: [
        CommonModule,
        NgxPermissionsModule.forChild(),
        MaterialModule,
        ReactiveFormsModule,
        FormsModule,
        RouterModule,
        PipesModule,
    ],
    declarations: [
        CrearCompetidorComponent,
        CrearCompetidorDialog,
        EditarCompetidorComponent,
        EditarCompetidorDialog,
        EliminarCompetidorComponent,
        EliminarCompetidorDialog,
        IrCompetidorComponent,
        CompetidorComponent,
        VerCompetidoresComponent,
    ],
    entryComponents: [
        CrearCompetidorDialog,
        EditarCompetidorDialog,
        EliminarCompetidorDialog,
    ],
    exports: [
        CrearCompetidorComponent,
        EditarCompetidorComponent,
        EliminarCompetidorComponent,
        IrCompetidorComponent,
        CompetidorComponent,
        VerCompetidoresComponent,
    ],
    providers: [
        CompetidorService
    ]
})
export class CompetidorModule { }